import React, { useState } from "react";
import TableCell from "@material-ui/core/TableCell";
import useAlertDialog from "../../../hooks/useAlertDialog";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";
import { TableRow } from "@material-ui/core";
import { OrderStatusLabelMap, PriceDetail } from "../../../../models/Order";
import moment from "moment";
import {
	BookingTableBodyButton,
	BookingTableBodyDate,
	BookingTableBodyStauts,
	TableCellFloatLeft,
	TableCellFloatLeftInner,
} from "../styled/DesStyled";
import useCancelOrder from "../hook/CancelOrder";
import useLoadedUser from "../../../hooks/auth/useLoadedUser";
import PermissionGate from "../../../controls/auth/PermissionGate";
import { UserRole } from "../../../../models/User";
import { formatOrderCalendarDate } from "../../../../utils/orderCalendarDate";

export default function BookingTableBody(props: {
	val: PriceDetail;
	reload: () => void;
	setIsDialogLoginOpen: (val: boolean) => void;
	setOrderId: (val: number) => void;
}) {
	const [load, setLoad] = useState(false);
	const { user } = useLoadedUser();
	const [anchorEl, setAnchorEl] = useState(null);
	const { openAlertDialog } = useAlertDialog();
	const { doCancelOrder } = useCancelOrder({ reload: props.reload, user: user, setLoad: setLoad });

	const handleUpdateStatusStaff = async (id: number) => {
		openAlertDialog?.(
			AlertType.Confirm,
			"You definitely want to cancel your order?",
			() => {},
			() => doCancelOrder(id || 0),
			undefined,
			{
				declineText: "Cancel",
				acceptText: "Confirm",
			}
		);
	};

	const handleUpdateOrder = async (id: number) => {
		props.setIsDialogLoginOpen(true);
		props.setOrderId(id);
	};

	return (
		<>
			<TableRow>
				<TableCell align="center">{props.val.id}</TableCell>
				<TableCell align="center">
					{" "}
					<TableCellFloatLeft>
						<TableCellFloatLeftInner>Name:</TableCellFloatLeftInner> {props.val.partner?.name}
					</TableCellFloatLeft>{" "}
					<TableCellFloatLeft>
						<TableCellFloatLeftInner>Address:</TableCellFloatLeftInner> {props.val.partner?.address}
					</TableCellFloatLeft>{" "}
				</TableCell>
				<TableCell align="center">{props.val.quantity}</TableCell>
				<TableCell align="center">{Math.round((props.val.totalMoney || 0) * 100) / 100} USD</TableCell>
				<TableCell align="center">
					<BookingTableBodyDate>
						{props.val.timeInString
							? formatOrderCalendarDate(props.val.timeInString)
							: (props.val.timeIn && formatOrderCalendarDate(props.val?.timeIn)) || ""}
					</BookingTableBodyDate>
					<br />
					<BookingTableBodyDate>
						{props.val.timeOutString
							? formatOrderCalendarDate(props.val.timeOutString)
							: (props.val.timeOut && formatOrderCalendarDate(props.val?.timeOut)) || ""}
					</BookingTableBodyDate>
				</TableCell>
				<TableCell align="center">
					<BookingTableBodyStauts status={props.val?.status}>
						{" "}
						{OrderStatusLabelMap.get(props.val?.status || 0)}
					</BookingTableBodyStauts>
				</TableCell>

				<TableCell align="center">
					{user?.role != UserRole.Partner && (
						<>
							<PermissionGate permission="orders.cancel">
								<BookingTableBodyButton
									loading={load}
									status={props.val?.status}
									onClick={() => handleUpdateStatusStaff(props.val.id || 0)}>
									{load ? "Loading ..." : "Cancel"}
								</BookingTableBodyButton>
							</PermissionGate>
							{user?.role == UserRole.Admin && (
								<PermissionGate permission="orders.edit">
									<BookingTableBodyButton
										status={1}
										onClick={() => handleUpdateOrder(props.val.id || 0)}>
										Edit
									</BookingTableBodyButton>
								</PermissionGate>
							)}
						</>
					)}
				</TableCell>
			</TableRow>
		</>
	);
}
